import {z} from 'zod'

export const PasswordRecoverySchema = z.object({
    email: z.string().min(1, {message: 'errors:email'}).email({message: 'errors:email_valid'})
})
